import React from "react";
import Group1 from "../Images/Group1.png";
import { Link, useLocation } from "react-router-dom";
import hbfhf from "../../src/Images/logo/icon.png";
import { useSelector } from "react-redux";

const Footer = () => {
  const location = useLocation();
  const { UserProfileID } = useSelector((state) => state.app);
  const currentYear = new Date().getFullYear();
  return (
    <>
      <div className={location.pathname === '/chat' ? 'hiddenfooter' : ''}>
        <section className="fottersection">
          <div className="cust_container">
            <div className="socialicon_wrap">
              <ul>
                <li className="icon">
                  <a href="https://www.facebook.com/neoosearch" target="_blank">
                    <i className="fa-brands fa-facebook"></i>
                  </a>
                </li>
                <li className="icon">
                  <a
                    href="https://www.instagram.com/neoo_search/"
                    target="_blank"
                  >
                    <i className="fa-brands fa-square-instagram"></i>
                  </a>
                </li>
                <li className="icon">
                  <a href="https://wa.me/971554799121" target="_blank">
                    <i className="fa-brands fa-square-whatsapp"></i>
                  </a>
                </li>
                <li className="icon">
                  <a
                    href="https://www.linkedin.com/in/neoo-search-72677432/"
                    target="_blank"
                  >
                    <i className="fa-brands fa-linkedin"></i>
                  </a>
                </li>
                <li className="icon">
                  <a href="https://x.com/neoosearch" target="_blank">
                    <i className="fa-brands fa-square-twitter"></i>
                  </a>
                </li>
              </ul>
            </div>

            <hr />

            <div className="fopterbg">
              <div className="imgfooterprl">
                <div className="">
                  <p className="howcan">How can we help? </p>
                </div>
                <div className="">
                  <Link to="/lets-get-intouch" className="contuctus_btn">
                    Contact Us
                  </Link>
                </div>
              </div>
              <div className="rightfootercontentwrap">
                <div className="fotercfyvflx">
                  <Link to="/about-neoo-search" className="txttftrtkjh">
                    About Us
                  </Link>
                  <Link to="/about-business-directory" className="txttftrtkjh">
                    Local directory
                  </Link>
                  <Link to="/products-and-services" className="txttftrtkjh">
                    Products and services
                  </Link>
                  {UserProfileID?.subscriptionId ? (
                    <Link to="/upgradeplan" className="txttftrtkjh">
                      Price & Plan
                    </Link>
                  ) : (
                    <Link to="/business-directory-listing-pricing" className="txttftrtkjh">
                      Price & Plan
                    </Link>
                  )}
                  <Link to="/business-reward-program" className="txttftrtkjh">
                    Rewards
                  </Link>
                  <Link to="/refer-and-earn" className="txttftrtkjh">
                    Refer & Earn
                  </Link>
                  <Link to="/about-neoocard" className="txttftrtkjh">
                    NeooCard
                  </Link>
                  <Link to="/technical-specification" className="txttftrtkjh">
                    Technical Specification
                  </Link>
                  <Link to="/faq" className="txttftrtkjh">
                    FAQ
                  </Link>
                  <Link to="/user-agreement" className="txttftrtkjh">
                    User Agreement
                  </Link>

                  <Link to="/terms-of-services" className="txttftrtkjh">
                    Terms & conditions{" "}
                  </Link>

                  <Link to="/privacy-policy" className="txttftrtkjh">
                    Privacy Policy
                  </Link>
                  {/* <Link to="/about-business-directory" className="txttftrtkjh">
                    About Local Directory
                  </Link> */}
                </div>

                <div className="footerafbhsvbhy">
                  <img src={hbfhf} className="img-fluid" alt="..." />
                  <p className="txtppcpy">
                    Copyright © {currentYear} Neoo Search FZE All Rights Reserved.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Footer;
